var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.575 11.65L6.225 9.3C6.09167 9.16667 5.925 9.1 5.725 9.1C5.525 9.1 5.35 9.175 5.2 9.325C5.05 9.475 4.975 9.65 4.975 9.85C4.975 10.05 5.05 10.225 5.2 10.375L7.95 13.125C8.11667 13.2917 8.325 13.375 8.575 13.375C8.825 13.375 9.04167 13.2917 9.225 13.125L14.8 7.525C14.9333 7.39167 15 7.225 15 7.025C15 6.825 14.925 6.65 14.775 6.5C14.625 6.35 14.45 6.275 14.25 6.275C14.05 6.275 13.875 6.35 13.725 6.5L8.575 11.65ZM10 19C8.68333 19 7.446 18.75 6.288 18.25C5.12933 17.75 4.125 17.075 3.275 16.225C2.425 15.375 1.75 14.3707 1.25 13.212C0.75 12.054 0.5 10.8167 0.5 9.5C0.5 8.18333 0.75 6.94567 1.25 5.787C1.75 4.629 2.425 3.625 3.275 2.775C4.125 1.925 5.12933 1.25 6.288 0.75C7.446 0.25 8.68333 0 10 0C11.3167 0 12.5543 0.25 13.713 0.75C14.871 1.25 15.875 1.925 16.725 2.775C17.575 3.625 18.25 4.629 18.75 5.787C19.25 6.94567 19.5 8.18333 19.5 9.5C19.5 10.8167 19.25 12.054 18.75 13.212C18.25 14.3707 17.575 15.375 16.725 16.225C15.875 17.075 14.871 17.75 13.713 18.25C12.5543 18.75 11.3167 19 10 19Z",
    fill: "#12B757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check-circle-green.4d943552f3b0d5f162fd9349e832a675.svg";
export { ForwardRef as ReactComponent };